/** Org-scoped roles assignable in the platform admin panel. */
export const ORG_ROLE_VALUES = [
  'org_admin',
  'internal_auditor',
  'external_auditor',
  'report_viewer',
] as const;

export type OrgRoleValue = (typeof ORG_ROLE_VALUES)[number];

export const DEFAULT_ORG_ROLE: OrgRoleValue = 'report_viewer';

export const ORG_ROLE_OPTIONS: { value: OrgRoleValue; label: string }[] = [
  { value: 'org_admin', label: 'Org Admin' },
  { value: 'internal_auditor', label: 'Internal Auditor' },
  { value: 'external_auditor', label: 'External Auditor' },
  { value: 'report_viewer', label: 'Report Viewer' },
];

/** Normalize a stored role for edit forms (assignable org roles only). */
export function normalizeOrgRoleForEdit(role?: string | null): OrgRoleValue {
  const r = (role ?? '').trim();
  if (r === 'org_admin' || r === 'internal_auditor' || r === 'external_auditor' || r === 'report_viewer') {
    return r;
  }
  return DEFAULT_ORG_ROLE;
}

/** User-readable label for a stored role value. */
export function formatOrgRoleLabel(role?: string | null): string {
  const r = (role ?? '').trim();
  if (!r) return '-';
  const match = ORG_ROLE_OPTIONS.find((opt) => opt.value === r);
  if (match) return match.label;
  return r;
}
